angular.module('cfn').directive('cfnDisplayTableheadHarvesttype', [
  '$rootScope',
  'i18nFilter',
  function($rootScope, i18nFilter) {
    return {
      template:
        "<th>{{'fe.directives.cfnDisplayTableheadHarvesttype.croptype'|i18n}}</th>" +
        "<th ng-if=\"!seedCoreController.isSwissBartoUser\">{{'fe.directives.cfnDisplayTableheadHarvesttype.factor'|i18n}}</th>"
    };
  }
]);

angular.module('cfn').directive('cfnDisplayTableitemHarvesttype', [
  '$rootScope',
  '$log',
  function($rootScope, $log) {
    return {
      template:
        "<td>{{item.sysHarvestType.type|enum:'HarvestTypeEnum'}}</td>" +
        "<td ng-if=\"!seedCoreController.isSwissBartoUser\">{{item.grainEquivalent|number}}</td>"
    };
  }
]);

angular.module('cfn').directive('cfnDisplayTableheadStockyard', [
  '$rootScope',
  'i18nFilter',
  function($rootScope, i18nFilter) {
    return {
      template:
        '<th>Nummer</th><th>' +
        i18nFilter(
          'fe.directives.cfnDisplayTableheadStockyard.content',
          'Inhalt'
        ) +
        '</th><th>' +
        i18nFilter(
          'fe.directives.cfnDisplayTableheadStockyard.stock',
          'Bestand'
        ) +
        '</th><th></th>'
    };
  }
]);
angular.module('cfn').directive('cfnDisplayTableitemStockyard', [
  '$rootScope',
  '$log',
  function($rootScope, $log) {
    return {
      template:
        '<td><cfn-input-text  id="number" model="item.number" class="input-block-level"></cfn-input-text></td>' +
        '<td><cfn-input-text  id="number" model="item.typeDisplayName" class="input-block-level" readonly="true"></cfn-input-text></td>' +
        '<td><cfn-input-double  id="inventory" model="item.inventory" class="input-block-level"></cfn-input-double></td>' +
        '<td><button class="btn imgOnly" ng-click="stockCoreController.stock_removeStockYards(item)"><span class="farmnet-delete" /></button></td>'
    };
  }
]);
